import { getStateWithOnlyOneLevel } from '../../utilities/StateSelectorHelper';

function getState(state) {
  return getStateWithOnlyOneLevel(state, 'audioAbbreviations');
}

export const getAudioAbbreviations = (state) =>
  getState(state).get('audioAbbreviations');

export const getIsAudioAbbreviationsImportingLoading = (state) =>
  getState(state).get('isAudioAbbreviationsImportingLoading');
